import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  
  // Get auth state and logout function
  const { isAuthenticated, logout, currentUser } = useAuth();

  React.useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  // Handle Logout Logic
  const handleLogout = async () => {
    try {
      await logout();
      setMenuOpen(false); // Close menu if open
    } catch (error) {
      console.error("Failed to log out:", error);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
        &#9776;
      </div>
      <div className="navbar-logo">
        <Link to="/">TravelApp</Link>
      </div>
      
      <div className={`navbar-links ${menuOpen ? 'active' : ''}`}>
        <div className="menu-header">
          <div className="close-icon" onClick={() => setMenuOpen(false)}>&times;</div>
          <span>TravelApp</span>
        </div>
        
        <Link to="/">Home</Link>
        <Link to="/destinations">Destinations</Link>
        <Link to="/about">About</Link>
        <Link to="/contact">Enquiry</Link>
        <Link to="/book-now" className="book-now-link">Book Now</Link>

        {/* --- AUTH SECTION --- */}
        {isAuthenticated ? (
          <>
            <Link to="/profile" className="navbar-profile-link">
              {currentUser?.profilePhoto ? (
                <img src={currentUser.profilePhoto} alt="Profile" className="navbar-profile-pic" />
              ) : (
                'Profile'
              )}
            </Link>
            
            {/* The Logout Button */}
            <button onClick={handleLogout} className="logout-button">
              Logout
            </button>
          </>
        ) : (
          <Link to="/login" className="navbar-login-link">Login</Link>
        )}
      </div>
    </nav>
  );
};

export default Navbar;